import eventBus from "@/services/eventBus";
import CarPostCalc, { carPostCalcDefaultProps } from "../models/CarPostCalc"
import CarPostCalcApi from "./CarPostCalcApi";
import { t } from "@/plugins/i18n";

export class CarPostCalcStore {
    carPostCalcs: CarPostCalc[] = [];
    carPostCalc: CarPostCalc = { ...carPostCalcDefaultProps };

    async getPostCalcs(invNo: number) {
        this.carPostCalcs = await CarPostCalcApi.getCarPostCalcs(invNo);
    }

    async generateCarPostCalc(invNo: number){
        const success = await CarPostCalcApi.generateCarPostCalc(invNo);
        if (success) {
            eventBus.$emit("success",t("PostCalc_SikeresUtokalkulacioGeneralas"));
        }
        else{
            eventBus.$emit("error",t("PostCalc_SikertelenUtokalkulacioGeneralas"));
        }
    }
}

const store = new CarPostCalcStore()
export default store